import React, { useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import Link from "next/link";
import Image from "next/image";
import { Assets } from "../list/Assets";
import styles from '../../styles/HorizontalScroll.module.css';
import SkeletonLoader from '../../src/components/SkeletonLoader';
import CardBadge from './CardBadge';

const Gridcom = dynamic(() => import('../components/Gridcom'), { });



// `eager`: how many of the first cards load straight away (top of the page, for a fast Largest Contentful Paint)
const HorizontalScroll = ({ games, category, viewMoreUrl, layoutType, showhot, onGameClick, headerExtra, eager = 0}) => {

  const [imageLoaded, setImageLoaded] = useState(false);

  const myImageLoader = ({ src }) => {
    return `${src}?w=100&q=100`;
  };
  const myImageLoaderNew = ({}) => {
    return `${Assets[0].new_l}?w=${100}&q=${100}`;
  };

  function newLabel(value) {
    if (value <= 4) {
      return (
        <div className= {styles.new_badge}>
          
          <Image
  loader={myImageLoaderNew}
  src="image-src"
  alt="new"
  fill
  sizes="100vw" // adjust this to match your container
  loading="lazy"
/>
        </div>
      );
    }
    return null;
  }


  const scrollContainerRef = useRef(null);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  const isLessThan30 = games.length < 30; // Check if the game count is less than 30

    // Conditional className assignment based on layoutType
  const wrapperClassName = layoutType === 'double' ? styles.grid_container
    : layoutType === 'compact' ? `${styles.grid_container2} ${styles.compact}`
    : styles.grid_container2;

  const Hot_thumb = showhot === 'yes';

  const [hoveredIndex, setHoveredIndex] = useState(null);

  // compact rows (Continue Playing) have no heading line: the heading is the row's first card,
  // which saves the height of a heading line at the top of the homepage
  const compact = layoutType === 'compact';

  return (

    <>
       {!compact && <div className={styles.header}>
        
        <div className={styles.header_container}><h2>{category} </h2>
        {viewMoreUrl && (
          <Link href={viewMoreUrl} className={styles.viewMoreButton} passHref>
          
            View More

          </Link>
        )}{headerExtra}</div>
        <div className={styles.header_container2}>
        <div onClick={scrollLeft} className={styles.scrollButton}>◀</div>
        <div onClick={scrollRight} className={styles.scrollButton}>▶</div>
        </div>
        
      </div>}
     
      <div data-section={category} className={`${styles.game_section} ${layoutType === 'double' ? styles.section_double : layoutType === 'compact' ? styles.section_compact : ''}`} ref={scrollContainerRef}>
      
        <div className= {wrapperClassName}>
          {compact && (
            <Link href={viewMoreUrl || '#'} prefetch={false} className={styles.labelCard}>
              <span className={styles.labelIcon}>
                <img src="/assets/sidenav/v2/recently-played.svg" alt="" width="26" height="26" />
              </span>
              <div className={styles.labelText}>
                <h2>{category}</h2>
                {viewMoreUrl && <span>See all ›</span>}
              </div>
            </Link>
          )}
          {games.map((game, index) => {
            // Determine the correct image source
           
            const imageUrl = game.hot === '2x2' && Hot_thumb? game.thumb_big : game.hot === '1x1' ? game.thumb : game.thumb;
            const Hotclass = game.hot === '2x2' && Hot_thumb ? `${styles.thumb_1x1} ${styles.thumb_2x2}`: styles.thumb_1x1;
            return (
              <Link key={index} href={game.path[0]} prefetch={false} className={Hotclass} title={compact ? game.name[0] : undefined} onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)} onClick={onGameClick ? () => onGameClick(game, index) : undefined} passHref >
              
               <div className={styles.thumb_container}>
                 <span className={styles.title}>{game.name[0]}</span>
                 {/* New / Trending / Rising / Exclusive badge (src/lib/badges.js); old Updated / Unblocked labels otherwise */}
                 {game.badge ? <CardBadge badge={game.badge} /> : <>
                   {game.label === 'Updated' &&<div  className={"Thumb_label Thumb_updated"}>{game.label}</div>}
                   {game.label === 'Unblocked' &&<div  className={"Thumb_label Thumb_Unblocked"}>{game.label}</div>}
                 </>}
                 <div className={styles.cover}/>
                 <div className={styles.thumb_img} style={{ width: '100%', height: '80%', position: 'relative' }}>
              

                      {/* Video overlay */}
                      {hoveredIndex === index && game.video ? (
                        
                        <video
                          src={game.video}
                          autoPlay
                          muted
                          loop
                          className={styles.gameVideo}
                          // style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      ) : null}
                      {/* Image */}
                      
                      {!imageLoaded && <SkeletonLoader />}
                      
                    <div
              className={styles.imageWrapper}
              style={{ opacity: imageLoaded || index < eager ? 1 : 0, transition: 'opacity 0.5s ease-in-out' }}
            >
               {game.platform === 'pc'&& (<div style={{ right: '0px', bottom: '0px',width: '37px',height: '30px',position: 'absolute', zIndex: 100,}}>
                      <Image
  loader={myImageLoader}
  src="/assets/pc-icon.svg"
  alt={game.name[0]}
  fill
  sizes="100vw" // adjust to match container size
  loading="lazy"
  className="PC_Icon"
  onLoad={() => setImageLoaded(false)}
/>
                      </div>)}
             <Image
  loader={myImageLoader}
  src={imageUrl}
  alt={game.name[0]}
  fill
  sizes="100vw" // adjust for your container width
  {...(index < eager ? { priority: true } : { loading: "lazy" })}
  className={hoveredIndex === index && game.video ? styles.imageOverlay : ''}
  onLoad={() => setImageLoaded(true)}
/>
            </div>
                 </div>
               </div>
               {/* {newLabel(index)} */}
             
           </Link>
            );
          })}
        </div>
      </div>
      </>
  );
};

export default HorizontalScroll;
